import { render, staticRenderFns } from "./s5-1.vue?vue&type=template&id=656d2bf8&scoped=true&"
import script from "./s5-1.vue?vue&type=script&lang=js&"
export * from "./s5-1.vue?vue&type=script&lang=js&"
import style0 from "./s5-1.vue?vue&type=style&index=0&id=656d2bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656d2bf8",
  null
  
)

export default component.exports